import { useContext } from 'react';
import { InitialStateContext } from '../context/InitialState';

export const useHeaders = () => {
  const { headers } = useContext(InitialStateContext);
  return headers;
};
